// extracted by mini-css-extract-plugin
module.exports = {"socialProofContainer":"style-module__socialProofContainer___14kzl"};